export default path => {
  const moduleName = path.split("/").map(s.capitalize).map(s.camelize).join("");

  require(
    ['view_models/' + path + '/module'],
    module => Kadenze[moduleName] = module.default
  )
}
